import React from 'react';
import { Modal,ModalHeader } from 'reactstrap';
import { ModalButtonSave, ModalButtonUpdate } from '../../constant';
import { FormMicTypeSample } from './FormMicTypeSample';
import { Dialog } from 'primereact/dialog';

export const ModalMicTypeSample = (props) => {
    const{
        modal, modalTitle, method, loading,
        name, abbreviation, handleInputChange, 
        validaciones, saveCreate, saveUpdate, closeDialog
    }=props;

    return (
        <Dialog 
            header={modalTitle}
            visible={modal}
            onHide={closeDialog}
            closable={true}
            modal
            blockScroll
            className='medium-dialog'
        >
       
            {
                method === "create"
                ?<FormMicTypeSample
                    button = {ModalButtonSave}
                    {...{closeDialog, loading, handleInputChange, validaciones, methodAction: saveCreate,}}
                />
                :
                (method === "update")
                ?
                <FormMicTypeSample
                    button={ModalButtonUpdate}
                    {...{ closeDialog, loading, handleInputChange, validaciones, methodAction: saveUpdate, name, abbreviation }}
                />
                :
                null
            }
        </Dialog>
    )
}